<template>
  <div class="coinflip-item d-flex px-2 py-1">
    <div class="item-info flex-grow-1 d-flex align-center">
      <div class="bg-ui-panel item-image pa-2 flex-grow-0 mr-3" :style="{'--color': item.color}">
        <v-img
          :src="`https://community.cloudflare.steamstatic.com/economy/image/${item.image}/164x164`"
          aspect-ratio="1" width="40"
        />
      </div>
      <p class="text--secondary mb-0 lh-1-3">
        {{ item.name }}
        <span v-if="item.amount > 1">
          (x{{ item.amount }})
        </span>
      </p>
    </div>

    <span class="text-body-2 mr-2 align-self-center">
      ${{ item.price * (item.amount || 1) | toScrap }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.coinflip-item {
  min-width: 0;
  background-color: rgba(#6e6b65, 0.85);

  .item-info {
    overflow: hidden;
  }

  .item-image {
    position: relative;

    .v-image {
      position: relative;
      z-index: 1;
    }

    &::before {
      position: absolute;
      z-index: 1;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.35;
      background: radial-gradient(var(--color), transparent);
      content: ' ';
    }
  }

  .scrap {
    user-select: none;

    .amount {
      position: absolute;
      right: 0;
      bottom: 0;
      text-shadow: 0 2px 2px black;
      font-weight: bold;
    }
  }
}
</style>
